export const defaultId = 'dai-profile-random-777';
export const defaultDisplayName = 'Random DAI Profile 777';
